import React from "react"
import parse from "html-react-parser"
import styled from "styled-components"

// import material ui
import Typography from "@material-ui/core/Typography"

import * as theme from "../../theme"

const Textarea = props => {
  const { content } = props

  let contentString

  if (typeof content === "string" || content instanceof String) {
    // Remove unnecessary tags which are automatically added by Wordpress when inserting an image
    contentString = content
      .toString()
      .replace("<html>", "")
      .replace("</html>", "")
      .replace("<head>", "")
      .replace("</head>", "")
      .replace("<body>", "")
      .replace("</body>", "")

    return parse(contentString).map((o, index) => {
      let variant = o.type

      // convert all for material ui unknown tags into variant
      if (variant) {
        if (variant === "p" || variant === "ul" || variant === "ol") {
          variant = "body1"
        }

        return (
          <Container key={index} {...props}>
            <Typography
              component="div"
              variant={variant}
              children={o}
              gutterBottom
            />
          </Container>
        )
      } else {
        return o
      }
    })
  } else {
    return null
  }
}

const Container = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a,
  span,
  strong {
    /* This makes the content inherit font-weight from mui theme instead of minireset.css */
    font-weight: inherit;
  }
  p,
  a,
  span,
  strong,
  ol,
  ul {
    margin-bottom: 20px;
  }

  h4 {
    margin-bottom: 10px;
  }

  a {
    color: ${theme.color.primary};
  }

  ul,
  ol {
    margin-left: 25px;
  }

  ul li {
    list-style: disc;
  }

  .gatsby-resp-image-wrapper {
    margin-bottom: 20px;
    /* max-width: 100% !important; */
  }
`

export default Textarea
